import React from "react";
import './styles.scss';

import {BtnBase, btnCtor} from "../BtnBase";
import Arrow from "../../../icons/ArrowLeftB";

export const BtnBlueFilled = btnCtor({className: 'btn--blue', filled: true});
export const BtnBlueOutlined = btnCtor({className: 'btn--blue', outlined: true});
export const BtnRedFilled = btnCtor({className: 'btn--red', filled: true});
export const BtnRedOutlined = btnCtor({className: 'btn--red', outlined: true});
export const BtnBlackFilled = btnCtor({className: 'btn--black', filled: true});
export const BtnBlackOutlined = btnCtor({className: 'btn--black', outlined: true});

export const BtnBack = (props) => {
  return (
    <BtnBase
      {...props}
      heightMedium
      square
    >
      <Arrow width="2.8rem" />
    </BtnBase>
  )
}
